
<div class="modern-header d-flex justify-space-between">
  <div class="d-flex flex-column">
    <h1 class="text-h5 font-weight-bold ma-0">
      <slot name="header-title" />
    </h1>
    <span class="text-caption">
      <slot name="header-caption" />
    </span>
  </div>
  <div class="d-flex align-center">
    <!-- Header Actions slot (for ViewToggle, buttons, etc.) -->
    <slot name="header-actions" />

    <!-- Product Switcher -->
    <product-switcher
      v-if="showProductSwitcher && products.length > 0"
      :products="products"
      @product-click="handleProductClick"
    />

    <!-- User menu -->
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          class="user-menu-btn text-body-2 blue-text darken-2 text-capitalize"
          text
          v-bind="attrs"
          v-on="on"
        >
          <span class="user-initials">
            {{ userInitials }}
          </span>
          <span>Hello {{ userName }}</span>
          <v-icon>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-list class="user-menu-list">
        <v-list-item @click="handleSupport">
          <lucide-icon name="HelpCircle" :size="18" class="mr-3" />
          Support
        </v-list-item>
        <v-list-item @click="handleLearningHub">
          <lucide-icon name="GraduationCap" :size="18" class="mr-3" />
          Learning HUB
        </v-list-item>
        <v-divider class="my-2" />
        <v-list-item @click="handleLogout">
          <lucide-icon name="LogOut" :size="18" class="mr-3" />
          Log Out
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</div>
